module.exports = __webpack_public_path__ + "static/media/artpro.25b5393f.png";